import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order } from "src/interfaces/Order";

interface OrdersState {
  orders: Order[];
  isSubscribed: boolean;
}

const initialState: OrdersState = {
  orders: [],
  isSubscribed: false,
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
      state.isSubscribed = true;
    },
  },
});

export const { setOrders } = ordersSlice.actions;

export default ordersSlice.reducer;
